import React from "react";
import { graphql } from "gatsby";
import { Row, Col } from "antd";
import { classNames } from "utils";

import Image from "components/Image";

import * as styles from "./SectionLogoRow.module.less";

/**
 * We use this to define what will be queried for this component
 * This also serves as typings (See `Gatsby.SectionLogoRowDataFragment` below)
 */
export const SectionLogoRowDataFragment = graphql`
  fragment CompaniesLogos on MarkdownRemark {
    frontmatter {
      name
      title
      logo {
        image {
          ...CompanyLogo
        }
        alt
        caption
      }
    }
  }

  fragment SectionLogoRowData on MarkdownRemarkFrontmatterSections {
    noTopMargin
    companiesList {
      ...CompaniesLogos
    }
    section_id
  }
`;

/**
 * @param {GatsbyTypes.SectionLogoRowDataFragment} props
 */
export default function SectionLogoRow({
  // title,
  noTopMargin,
  companiesList = [],
  section_id,
}) {
  return (
    <section
      id={section_id}
      className={classNames(styles.logoRow, {
        [styles.logoRowNoTopMargin]: noTopMargin,
      })}
    >
      <Row
        justify="space-around"
        align="middle"
        gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 24]}
      >
        {companiesList.map((company, index) => (
          <Col
            key={`companyLogos-${index}`}
            xs={24}
            sm={12}
            md={6}
            lg={Math.floor(24 / companiesList.length)}
          >
            <LogoCard company={company} />
          </Col>
        ))}
      </Row>
    </section>
  );
}

/**
 * @param {{ company: GatsbyTypes.CompaniesLogosFragment | string;}} props
 */
const LogoCard = ({ company }) => {
  if (
    typeof window !== "undefined" &&
    window.NETLIFY_CMS &&
    typeof company === "string"
  ) {
    return (
      <Image
        className={styles.companyLogo}
        src={null}
        title={"caption"}
        alt={"alt"}
        publicURL={`https://via.placeholder.com/225x225.png?text=${company}'s+avatar`}
      />
    );
  }

  const {
    frontmatter: { logo },
  } = /** @type {GatsbyTypes.CompaniesLogosFragment} */ (company);

  const { image, alt, caption } = logo || {};

  const { logoData, publicURL } = image || {
    logoData: null,
    publicURL: null,
  };

  return (
    <Image
      className={styles.companyLogo}
      src={logoData}
      alt={alt || caption}
      title={caption || alt}
      publicURL={publicURL}
      imgStyle={{
        objectFit: "contain",
      }}
    />
  );
};
